import React, {
    useState
    , useEffect
    , useContext 
    , useLayoutEffect
}                           from 'react'
import { 
  MDBCollapse
  , MDBRow
  , MDBCol
}                           from 'mdb-react-ui-kit';
import { Check }            from './elements/Checkfunction'
import { ElementOrg }       from './elements/ElementsOrg'
import { baseConvert }      from './functions/baseConvert'
import { BarComponent }     from './elements/BarComponent'
import { useMain }          from './Hooks/useMain'
import Header               from './Header'
import SelectComponent      from './elements/SelectComponent'
import NumericInput         from './elements/NumericInput'
import InputNormal          from './elements/InputNormal'
import '../styles/styles.css'
import Swal                 from 'sweetalert2'
import Fondo                from '../assets/FondoGris.svg'
import FileInput            from './elements/FileInput'
import ClientAxios          from '../config/clientAxios'
import LoginContext         from '../context/Login/LoginContext'
import PrivacidadComponent  from './PrivacidadComponent'
import NumberFormat         from 'react-number-format'
// import Fondo from '../assets/Fondo.png'
// import Fondo from '../assets/Fondo2.jpg'
// import logo from '../assets/logo.png'
// import useChecker from './elements/useCheck'
// import axios from 'axios'
// import { Redirect } from 'react-router'
// import { zfill } from './elements/FillNumbers'

const MainComponent = (props) => {
  
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();

    Swal.fire({
    
      width: 700,
      backdrop: `
      rgba(177, 182, 154, 0.73)
        left top
        no-repeat
      `,
      html: `
        <p style="text-align: justify; font-size: 25px;">
          Caja Popular Apaseo el Alto pone a tu disposición este portal como medio de contacto para iniciar tu trámite de crédito.
        </p>
  
        <p style="text-align: justify">
          Es un requisito indispensable que para el uso de esta herramienta cuentes con tus datos actualizados en nuestra sucursal.
        </p>
        
        <p style="text-align: justify">
          En caso de realizar tu registro pero no hacer la confirmación correspondiente de términos y condiciones así como de consulta para buró, este registro será eliminado y podrás elaborar un nuevo registro pasadas las 24 horas.
        </p>
      `
    })
    
    
  }, [])
    

  const { 
    DataDocumentos
    , State
    , IngresosTotales
    , totalMoney
    , handleChange
    , handleChangeLower
    , handleChangeNew
    , setState
    , setDataDocumentos
    // SaldoCredito,
    // fechas
  } = useMain()

  const [TitleState, setTitleState] = useState('')
  const [Progress, setProgress]     = useState(0)
  const [Counter, setCounter]       = useState(1)
  const [Loader, setLoader]         = useState(2)

  const [ShowElement2, setShowElement2] = useState(false)
  const [Elementos, setElementos]       = useState({
    Bienvenida: true,
    ShowElement: false,
    ShowElement3: false,  
  })
  
  
  const { //* destructuring to use the elements into this page
    Bienvenida
    , ShowElement
    // ShowElement3
  } = Elementos
  
  const loginContext                  = useContext(LoginContext)
  const {ReturnAuth, authentication}  = loginContext

  useEffect(() => {
    if(authentication){
      props.history.push('/credito/buro')
    }
  }, [authentication, props.history])
  
  const handleClick = element => {
    switch (element) {
      case 1:
        setProgress(0)
        setTitleState('Datos personales')
        setShowElement2(false)
        setElementos({
          Bienvenida   : sessionStorage.getItem('registro') === 'true' ? true : false,
          ShowElement  : sessionStorage.getItem('registro') === 'true' ? false : true,
          ShowElement3 : false,
        })
        
        break;
      case 2:
        setProgress(50)
        setTitleState('domiciliarios y valores')
        setShowElement2(true)
        setElementos({
          Bienvenida   : false,
          ShowElement  : false,
          ShowElement3 : false,
        })
      break;      
      case 3:
        setProgress(100)
        setTitleState('Aviso de Privacidad / Terminos y condiciones')
        setShowElement2(false)
        setElementos({
          Bienvenida   : true,
          ShowElement  : false,
          ShowElement3 : false,
        })
      break;      
      default:
        break;
    }
  }

  //* this is to destructur information and use only the name of the value
  const { 
    numerosocio
    , apellidopaterno
    , apellidomaterno
    , nombre
    , domicilio
    , telefono
    , email
    , ciudad
    , estado
    , codigopostal
    , finalidadprestamo
    , aniosexperiencia
    , actividadeconomica
    , monto
    , plazopago
    , sueldoingreso
    , otrosingreso
    , curp
    , colonia              
    , gs_vivienda          
    , gs_entretenimientodig
    , gs_alimentacion      
    , gs_movil             
    , gs_aseo              
    , gs_transporte        
    , gs_vehiculo          
    , gs_salud             
    , gs_agua              
    , gs_entretenimiento   
    , gs_predial           
    , gs_vestimenta        
    , gs_luz               
    , gs_impuestospension  
    , gs_gas               
    , gs_otrosgastos       
    //* campos comentados despues de determinación de utilizar menos información
    // socio,
    , sucursalid
    // registrofederal,
    // tciudad,
    // tipovivienda,
    // tdomicilio,
    // casavalue,
    // terrenosvalue,
    // vehiculosvalue,
    // estadocivil,
    // edad,
    // niveleducacion,
    // comprobantedomicilioNombre,
    // comprobantedomicilio,
    // identificacionfrenteNombre,
    // identificacionfrente,
    // identificacionreverso,
    // identificacionreversoNombre,
    // fechanacimiento,
    // dianacimiento,
    // mesnacimiento,
    // yearnacimiento,
    // comprobanteingresos,
    // saldodisponiblecredito
  } = State

  useLayoutEffect(() => {
    totalMoney()
    // eslint-disable-next-line
  }, [
    otrosingreso
    , sueldoingreso
    , gs_vivienda          
    , gs_entretenimientodig
    , gs_alimentacion      
    , gs_movil             
    , gs_aseo              
    , gs_transporte        
    , gs_vehiculo          
    , gs_salud             
    , gs_agua              
    , gs_entretenimiento   
    , gs_predial           
    , gs_vestimenta        
    , gs_luz               
    , gs_impuestospension  
    , gs_gas               
    , gs_otrosgastos       
  ])
  
  //* PARA NIP
  const [nipBuro, setnipBuro] = useState({
    nip: ""
  })
  const {
    nip
  }                       = nipBuro
  const buro_ntransaccion = sessionStorage.getItem('buro_ntransaccion')

  const handleNip = (event) => {
    setnipBuro({
      ...nipBuro,
      [event.target.name] : event.target.value
    })
  }

  const nipSubmit = async (e) => {
    e.preventDefault()
    const responseNip = await ClientAxios.post('/api/nip', {nip, buro_ntransaccion}, {
      headers:{"x-auth-token": sessionStorage.getItem('token')}
    })

    if (responseNip.data.error === true) {
      Swal.fire({
        icon              : "error",
        title             : responseNip.data.msg,
        confirmButtonText : "ok"
      })
      sessionStorage.setItem('primera', responseNip.data.primera)
    }else if (responseNip.data.error === false) {
      sessionStorage.setItem('primera', responseNip.data.primera)
      ReturnAuth()
    }
    
  }
  //* PARA NIP

  const onSubmit = async e => {
    e.preventDefault()
    Swal.fire({
      title: '¿Desea realizar el registro?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Si',
      denyButtonText: `No`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        sendInfo()
      } else if (result.isDenied) {
        // Swal.fire('Los cambios no han sido guardados', '', 'info')
      }
    })
  }
  
  console.log(State);
  
  const sendInfo = async e => {
    sessionStorage.setItem('jsonData'         , JSON.stringify(State))
    sessionStorage.setItem('jsonDocData'      , JSON.stringify(DataDocumentos))
    const Number = Check(State)
    State.CDomicilio_DocName = DataDocumentos.CDomicilio_DocName
    State.CDomicilio_DocType = DataDocumentos.CDomicilio_DocType
    State.IFrente_DocName    = DataDocumentos.IFrente_DocName
    State.IFrente_DocType    = DataDocumentos.IFrente_DocType
    State.IReverso_DocName   = DataDocumentos.IReverso_DocName
    State.IReverso_DocType   = DataDocumentos.IReverso_DocType
    State.CIngresos_DocName  = DataDocumentos.CIngresos_DocName
    State.CIngresos_DocType  = DataDocumentos.CIngresos_DocType
    // setLoader(1) 
    console.log(JSON.parse(sessionStorage.getItem('jsonData')));
    switch (Number.value) {
      case 0:
        const response =  await ClientAxios.post('/api/solicitud', State)
        
        if (response.data.error === false) {
          sessionStorage.setItem('registro'         , response.data.registro)
          sessionStorage.setItem('token'            , response.data.token)
          sessionStorage.setItem('buro_ntransaccion', response.data.buro_ntransaccion)
          
          setLoader(0)
          Swal.fire({
            icon  :'success',
            title : 'Excelente',
            text  : 'Excelente, de favor se requiere la confirmación para la consulta de buro'
          })
          

          // setDataDocumentos({
          //   CDomicilio_DocName   : ''
          //   ,CDomicilio_DocType  : ''
          //   ,IFrente_DocName     : ''
          //   ,IFrente_DocType     : ''
          //   ,IReverso_DocName    : ''
          //   ,IReverso_DocType    : ''
          //   ,CIngresos_DocName   : ''
          //   ,CIngresos_DocType   : ''
          // })
          
          handleClick(3)
          setCounter(3)
        }else{
          if (response.data.error === true) {
            setLoader(0)
            Swal.fire({
              icon  :'error',
              title : response.data.msg,
              text  : response.data.sub
            })
          }
        }
      break;

      case 1:
        Swal.fire({
          icon  : 'error',
          title : Number.title,
          text  : Number.msg
        })    
        setLoader(0)
        handleClick(1)
        setCounter(Number.value)
      break;

      case 2:
        Swal.fire({
          icon  : 'error',
          title : Number.title,
          text  : Number.msg,
        })    
        setLoader(0)
        handleClick(2)
        setCounter(Number.value)
      break;

      case 3:
        Swal.fire({
          icon  : 'error',
          title : Number.title,
          text  : Number.msg,
        })    
        setLoader(0)
        handleClick(3)
        setCounter(Number.value)
      break;
    
      default:  
      break;
    }
  }

  useEffect(() => {
    handleClick(Counter)
  }, [Counter])


  const uploaadimage = async (e) => { //* to convert images to base64
    
    
    try {
      const file   = e.target.files[0];
      const base64 = await baseConvert(file)      
      setState({
        ...State,
        [e.target.name] : base64.split(',')[1]
      })
      var tipodato =  e.target.files[0].type
      console.log(tipodato);
      
      
      if (
        tipodato !== 'image/jpeg'
        && tipodato !== 'image/jpg'
        && tipodato !== 'image/png'
      ) {
        Swal.fire({
          icon: "error"
          ,text: "Formato no permitido"
        })
        document.getElementById(e.target.id).value = '';

        return;
      }

      setDataDocumentos({
        CDomicilio_DocName   : e.target.name === 'comprobantedomicilio' ? e.target.files[0].name :  DataDocumentos.CDomicilio_DocName
        ,CDomicilio_DocType  : e.target.name === 'comprobantedomicilio' ? e.target.files[0].type :  DataDocumentos.CDomicilio_DocType
        ,IFrente_DocName     : e.target.name === 'identificacionfrente' ? e.target.files[0].name :  DataDocumentos.IFrente_DocName
        ,IFrente_DocType     : e.target.name === 'identificacionfrente' ? e.target.files[0].type :  DataDocumentos.IFrente_DocType
        ,IReverso_DocName    : e.target.name === 'identificacionreverso' ? e.target.files[0].name : DataDocumentos.IReverso_DocName
        ,IReverso_DocType    : e.target.name === 'identificacionreverso' ? e.target.files[0].type : DataDocumentos.IReverso_DocType
        ,CIngresos_DocName   : e.target.name === 'comprobanteingresos' ? e.target.files[0].name :   DataDocumentos.CIngresos_DocName
        ,CIngresos_DocType   : e.target.name === 'comprobanteingresos' ? e.target.files[0].type :   DataDocumentos.CIngresos_DocType
      })
      
    } catch (error) {
      setState({
        ...State,
        [e.target.name] : ""
      })
      console.log(error)
    }
    
  }

  const mystyle = {
    backgroundsize          : 'cover'
    , backgroundAttachment  : 'fixed'
    , backgroundImage       : `url(${Fondo})`
    , backgroundPosition    : 'right top'
    , height                : `${window.innerHeight}`
    , width                 : `${window.innerWidth}`
    , color                 : 'black',
  };


  
  return (
  <>
    {Loader === 1 ? (
      
      <div className='contenedorAnima'>
        
        <div class="book">
          <div class="inner">
            <div class="left"></div>
            <div class="middle"></div>
            <div class="right"></div>
          </div>
          <ul>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
          
      </div>
    ) : (
    <div 
      className={`cover-container main-cpa-cover-container d-flex w-100 h-100 p-3 mx-auto flex-column bg-image-institutional`}
      style={mystyle} 
    >
      <Header/>
      <BarComponent
        TitleState={TitleState}
        ProgressShow={true}
        Progress={Progress}
        Counter={Counter}
        setCounter={setCounter}
      />


      <main className={`justify-content-center px-3 mt-5 col-12 container `} >
      <MDBRow>
        <MDBCol
        className="col-12"
        >
          <form className="col-xl-12 col-sm-12" onSubmit={onSubmit} autoComplete="off" >
            <MDBCollapse show={ShowElement} className='col-12'>
              <h4>Datos personales</h4>
                <NumericInput
                  title="Número de socio"
                  id="numerosocioId"
                  name="numerosocio"
                  placeHolder="Ingresa tu número de socio"
                  // disable={socio === "true" ? false : true}
                  value={numerosocio}
                  minNumber={0}
                  maxNumber={9999999999}
                  onChange={handleChangeLower}
                  isOblig={true}
                />
                <InputNormal 
                  title="Apellido Paterno"
                  id="apepaId"
                  name="apellidopaterno"
                  placeHolder="Ingresar tu apellido paterno"
                  value={apellidopaterno}
                  onChange={handleChange}
                  isOblig={true}
                />
                <InputNormal 
                  title="Apellido Materno"
                  id="apemaId"
                  name="apellidomaterno"
                  placeHolder="Ingresar tu apellido materno"
                  value={apellidomaterno}
                  onChange={handleChange}
                  isOblig = {true}
                />
                <InputNormal 
                  title="Nombre (s)"
                  id="nombreId"
                  name="nombre"
                  placeHolder="Ingresar tu nombre (s)"
                  value={nombre}
                  onChange={handleChange}
                  isOblig = {true}
                />
                {/* <InputNormal 

                  title="RFC"
                  id="rfcId"
                  name="registrofederal"
                  length={13}
                  placeHolder="Ingresa tu RFC, preferentemente con la homoclave"
                  value={registrofederal}
                  onChange={handleChange}
                /> */}
                <InputNormal 
                  title="CURP"
                  id="curpId"
                  name="curp"
                  length={18}
                  placeHolder="Ingresa tu CURP (18 dígitos)"
                  value={curp}
                  onChange={handleChange}
                  isOblig = {true}
                />
                <InputNormal 
                  title="Domicilio (Calle y número, sin abreviar)"
                  id="domicilioId"
                  name="domicilio"
                  placeHolder="Ingresa el nombre de la Calle y Número, donde vives actualmente"
                  value={domicilio}
                  onChange={handleChange}
                  isOblig = {true}
                />

                <InputNormal 
                  title="Colonia / Localidad"
                  id="coloniaid"
                  name="colonia"
                  placeHolder="Ingresa el nombre de la colonia o localidad, donde vives actualmente"
                  value={colonia}
                  onChange={handleChange}
                  isOblig = {true}
                />
                <InputNormal 
                  title="Municipio"
                  id="ciudadid"
                  name="ciudad"
                  placeHolder="Ingresa el nombre del Municipio, donde vives actualmente"
                  value={ciudad}
                  onChange={handleChange}
                  isOblig = {true}
                />
                <SelectComponent
                  title="Estado"
                  id="estadoid"
                  name="estado"
                  value={estado}
                  placeHolder="Selecciona el Estado, donde vives actualmente"
                  onChange={handleChangeLower}
                  value1="GUANAJUATO"
                  //isDisabled={true}
                  value2="HIDALGO"
                  value3="EDO. DE MÉXICO"
                  value4="MORELOS"
                  value5="QUERÉTARO"
                />
                <NumericInput 
                  title="Código Postal"
                  id="postalid"
                  name="codigopostal"
                  placeHolder="Ingresa el Código Postal, donde vives actualmente"
                  value={codigopostal}
                  onChange={handleChangeLower}
                  isOblig = {true}
                />

                <FileInput
                  title="Comprobante de domicilio"
                  id="comprobantedomicilioID"
                  name="comprobantedomicilio"
                  // value={comprobantedomicilioNombre}
                  onChange={uploaadimage}
                  placeHolder="Comprobante de domicilio"

                />

                <InputNormal
                  title="Teléfono celular"
                  id="telefonoId"
                  name="telefono"
                  placeHolder="Teléfono celular (10 dígitos, sin espacios ni símbolos, Ejemplo: 4455661122)"
                  length={10}
                  value={telefono}
                  onChange={handleChange}
                  isOblig = {true}
                />
                <InputNormal 
                  title="Correo electrónico"
                  id="emailId"
                  name="email"
                  placeHolder="Ingresa tu correo electrónico"
                  value={email}
                  onChange={e => {
                    setState({
                      ...State,
                      [e.target.name] : e.target.value.trim()
                    })
                  }}
                  isOblig = {true}
                />

                <label className="form-label mt-2" htmlFor="sucursalidId">Sucursal donde desea realizar el trámite <label style={{color: 'red'}}>*</label></label>
                {ElementOrg(estado, "sucursalid", handleChangeLower)}

                <FileInput
                  title="Identificación oficial vigente (adverso)"
                  id="identificacionfrenteID"
                  name="identificacionfrente"
                  // value={identificacionfrenteNombre}
                  onChange={uploaadimage}
                  placeHolder="Identificación oficial (frente)"
                />

                <FileInput
                  title="identificación oficial (reverso)"
                  id="identificacionreversoID"
                  name="identificacionreverso"
                  // value={identificacionreversoNombre}
                  onChange={uploaadimage}
                  placeHolder="Identificación oficial (reverso)"
                />
            
                <br/><br/>  
              
            </MDBCollapse>

            <MDBCollapse show={ShowElement2} className='col-12 w-100 h-100'>
                <MDBRow >
                  <h4>Datos del crédito</h4>
                  
                  <MDBCol className="col-12 col-lg-4">
                    
                    <label className="form-label mt-2" htmlFor="montoID" >Monto del crédito que solicitas <label style={{color: 'red'}}>*</label></label>
                    <NumberFormat 
                      id="montoID"
                      thousandSeparator={true} 
                      prefix={'$'}
                      onValueChange={handleChangeNew}  
                      value={monto}
                      name="monto"
                      className="form-control"
                      placeholder="Ingresa el monto que solicitas"
                    />
                  </MDBCol>
                  <MDBCol>
                    <NumericInput
                      title="Tiempo que requieres para pagar el crédito (meses)"
                      id="plazoID"
                      name="plazopago"
                      placeHolder="Ingresa el plazo que deseas pagar el crédito "
                      value={plazopago}
                      onChange={handleChange}
                      isOblig = {true}
                    />
                  </MDBCol>
                  <MDBCol className="col-12 col-lg-4">
                    <label htmlFor="finalidadprestamoId">Destino que le darás al crédito <label style={{color: 'red'}} >*</label></label>
                    <textarea
                      name="finalidadprestamo"
                      id="finalidadprestamoId"
                      cols="12"
                      rows="2"
                      className='col-12 form-control'
                      onChange={handleChange}
                      placeholder="Ingresa la finalidad del crédito"
                      value={finalidadprestamo}
                    >
                    </textarea>
                  </MDBCol>
                <hr className="mt-4" style={{color: "#000"}} />
                </MDBRow>
                
                <MDBRow>
                  <MDBCol className="col-12 col-lg-12 mt-2">
                    <label className="form-label" htmlFor="comprobanteingresosID" >Comprobante de ingresos</label>
                    <input 
                      type="file"
                      id="comprobanteingresosID"
                      name="comprobanteingresos"
                      // value={identificacionreversoNombre}
                      className="form-control"
                      accept="image/png, image/jpeg, image/jpg "
                      onChange={(e) => {
                        uploaadimage(e)
                      }}
                    />
                  </MDBCol >

                </MDBRow>

                {/*  CAMBIO DERIBADO DE REUNION OMAR */}
                
                {/* <h4>Capacidad de pago</h4>
                <MDBRow>
                  <InputNormal 
                    title="Ocupación"
                    id="actividadeconomicaId"
                    name="actividadeconomica"
                    placeHolder="Ingresa tu ocupación que actualmente desarrollas"
                    value={actividadeconomica}
                    onChange={handleChange}
                    isOblig = {true}
                  />
                  <NumericInput
                    title="Antigüedad en empleo o empresa"
                    id="aniosexperienciaId"
                    name="aniosexperiencia"
                    placeHolder="Ingrese los años que tiene de experiencia en su empleo o empresa"
                    value={aniosexperiencia}
                    minNumber={0}
                    maxNumber={100}
                    onChange={handleChange}
                    isOblig = {true}
                  />
                  <hr style={{color: "#000"}} />
                </MDBRow>
                <MDBRow>
                  <h5>Ingresos mensuales</h5>
                  <MDBCol className="col-12 col-lg-6">
                    <label className="form-label mt-2" htmlFor="sueldoingresoID">Sueldo (neto) <label style={{color: 'red'}}>*</label> </label>
                    <NumberFormat 
                      title="Ingresos"
                      id="sueldoingresoID"
                      thousandSeparator={true} 
                      prefix={'$'}
                      onValueChange={handleChangeNew}  
                      value={sueldoingreso}
                      name="sueldoingreso"
                      className="form-control"
                      placeholder="Ingresa el sueldo neto que percibes mensualmente"

                    />
                  </MDBCol>
                  <MDBCol className="col-12 col-lg-6">
                    <label className="form-label mt-2" htmlFor="otrosingresosID">Otros ingresos (esposa, hijos, negocios, inversiones) <label style={{color: 'red'}}>*</label></label>
                    
                    <NumberFormat 
                      id="otrosingresosID"
                      thousandSeparator={true} 
                      prefix={'$'}
                      onValueChange={handleChangeNew}  
                      value={otrosingreso}
                      name="otrosingreso"
                      className="form-control"
                      placeholder="Ingresa otros ingresos que percibes mensualmente"
                    />
                  </MDBCol  >
                  <MDBCol className="col-12 col-lg-6">
                    <label className="form-label mt-2" htmlFor="ingresototalID">Ingreso total</label>
                    <NumberFormat 
                      id="ingresototalID"
                      thousandSeparator={true} 
                      prefix={'$'}
                      disabled={true}
                      
                      value={IngresosTotales}
                      name="ingresototal"
                      className="form-control"
                      placeholder="Este cálculo es hecho automáticamente con el sueldo ingresado y los otros ingresos que hallan sido ingresados"
                    />
                  </MDBCol>
                  <MDBCol className="col-12 col-lg-6 mt-2">
                    <label className="form-label" htmlFor="comprobanteingresosID" >Comprobante de ingresos</label>
                    <input 
                      type="file"
                      id="comprobanteingresosID"
                      name="comprobanteingresos"
                      // value={identificacionreversoNombre}
                      className="form-control"
                      accept="image/png, image/jpeg, image/jpg, application/pdf"
                      onChange={(e) => {
                        uploaadimage(e)
                      }}
                    />
                  </MDBCol >
                </MDBRow> 
                
             

                <hr style={{color: "#000"}} />
                <MDBRow
                  center={true}
                >
                  <h5>Gastos de la unidad familiar</h5>
                  <MDBRow>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="viviendarentaID">Vivienda (renta, empleada doméstica) <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="viviendarentaID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_vivienda}
                        onValueChange={handleChangeNew} 
                        // disabled={tipovivienda === "RENTADA" ? false : true} 
                        name="gs_vivienda"
                        className="form-control"
                        // placeholder="ingresa los gastos por concepto de vivienda especificamente renta, si no percibe este gasto no es necesario modificar nada en este campo"
                      />
                    </MDBCol>
                  
                    <MDBCol>
                      <label className="form-label mt-2" htmlFor="vestimentaID">Télefono, internet, cable <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="vestimentaID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_entretenimientodig}
                        onValueChange={handleChangeNew}  
                        name="gs_entretenimientodig"
                        className="form-control"
                        // placeholder="ingresa los gastos por concepto de Vestimenta y Calzado"
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      <label className="form-label mt-2" htmlFor="alimentaciongastoID">Alimentación <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="alimentaciongastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_alimentacion}
                        onValueChange={handleChangeNew} 
                        // disabled={tipovivienda === "RENTADA" ? false : true} 
                        name="gs_alimentacion"
                        className="form-control"
                        // placeholder="ingresa los gastos por concepto de vivienda especificamente renta, si no percibe este gasto no es necesario modificar nada en este campo"
                      />
                    </MDBCol>
                    <MDBCol>
                      <label className="form-label mt-2" htmlFor="serviciosgastoID">Teléfono celular <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="serviciosgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_movil}
                        onValueChange={handleChangeNew} 
                        name="gs_movil"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de Servicios basicos"
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="saludgastoID">Aseo personal y doméstico <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="saludgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_aseo}
                        onValueChange={handleChangeNew} 
                        name="gs_aseo"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de Salud"
                      />
                    </MDBCol>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="transportegastoID">Transporte <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="transportegastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_transporte}
                        onValueChange={handleChangeNew} 
                        name="gs_transporte"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de Educación"
                      />
                    </MDBCol>
                  </MDBRow>
                  
                  <MDBRow>
                    <MDBCol>
                      <label className="form-label mt-2" htmlFor="vehiculogastoID">Vehículo (combustible, seguro, etc) <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="vehiculogastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_vehiculo}
                        onValueChange={handleChangeNew} 
                        name="gs_vehiculo"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de Vehículos y transporte, como mantenimiento, gasolina, etc.. o pasajes en caso de movilización en transporte público o privado por paga"
                      />
                    </MDBCol>
                    <MDBCol>

                      <label className="form-label mt-2" htmlFor="saludId">Salud <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="saludId"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_salud}
                        onValueChange={handleChangeNew} 
                        name="gs_salud"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de teléfono"
                      />
                    </MDBCol>                
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="aguagastoID">Agua <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="aguagastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_agua}
                        onValueChange={handleChangeNew} 
                        name="gs_agua"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de Pensión"
                      />
                    </MDBCol>
                                  
                    <MDBCol>
                      <label className="form-label mt-2" htmlFor="entretenimientogastoID">Diversión o recreación <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="entretenimientogastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_entretenimiento}
                        onValueChange={handleChangeNew} 
                        name="gs_entretenimiento"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de Deudas con instituciones financieras"
                      />
                    </MDBCol>                
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="predialgastoID">Predial <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="predialgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_predial}
                        onValueChange={handleChangeNew} 
                        name="gs_predial"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de otros servicios"
                      />
                    </MDBCol>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="ropagastoID">Ropa y calzado <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="ropagastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_vestimenta}
                        onValueChange={handleChangeNew} 
                        name="gs_vestimenta"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de otros gastos"
                      />
                    </MDBCol>  
                    
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="luzgastoID">Luz <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="luzgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_luz}
                        onValueChange={handleChangeNew} 
                        name="gs_luz"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de otros servicios"
                      />
                    </MDBCol>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="impuestosgastoID">Impuestos y pensiones <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="impuestosgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_impuestospension}
                        onValueChange={handleChangeNew} 
                        name="gs_impuestospension"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de otros gastos"
                      />
                    </MDBCol>  
                    
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="gasgastoID">Gas <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="gasgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_gas}
                        onValueChange={handleChangeNew} 
                        name="gs_gas"
                        className="form-control"
                        placeholder="ingresa los gastos por concepto de otros servicios"
                      />
                    </MDBCol>
                    <MDBCol>
                      
                      <label className="form-label mt-2" htmlFor="otrosgastoID">Otros gastos <label style={{color: 'red'}}>*</label></label>
                      <NumberFormat 
                        id="otrosgastoID"
                        thousandSeparator={true} 
                        prefix={'$'}
                        value={gs_otrosgastos}
                        onValueChange={handleChangeNew} 
                        name="gs_otrosgastos"

                        className="form-control"
                        placeholder="ingresa los gastos por concepto de otros gastos"
                      />
                    </MDBCol>  
                    
                  </MDBRow>
                </MDBRow>
                <hr style={{color: "#000"}} />

                */}
                {/* FIN CAMBIO DERIBADO DE REUNION OMAR */}

                <MDBRow
                  center={true}
                >

                  
                  
                  <div className="row justify-content-center">
                    
                    <button type="submit" className="btn btn-primary mt-4 col-4">Siguiente</button>
                    
                    
                  </div>
                </MDBRow>
                  <br/><br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                
              </MDBCollapse>
              
              <MDBCol
                className="col-12"
              >
                
                

              </MDBCol>
            </form>
            {/* <button className='btn btn-primary' onClick={() => setLoader(1)}>Test</button> */}

              <MDBCollapse show={Bienvenida} className='col-12 text-justify ps-4'>
                
                <PrivacidadComponent/>
                <form
                  onSubmit={nipSubmit}
                >
                  <label className="form-label mt-2" htmlFor="nipID">nip de acceso</label>
                  <input
                    type="password"
                    className="form-control mb-3 text-center"
                    id="nipID"
                    maxLength={4}
                    name="nip"
                    value={nip}
                    placeHolder="Ingres el nip enviado al correo anteriormente indicado"
                    onChange={handleNip}
                  />
                  <div>
                    <button className="btn btn-info"> Siguiente </button>
                    
                  </div>
                </form>
                
              </MDBCollapse>
          </MDBCol>
        </MDBRow>
      </main>

      {
        Counter >= 2 ? (
          null
        ):(
          <BarComponent
            TitleState={TitleState}
            ProgressShow={false}
            // Progress={Progress}
            Counter={Counter}
            setCounter={setCounter}
          />
        )
      }
    </div>
    )}

    
  </>
  )
  
}

export default MainComponent
